import React, {
  DetailedHTMLProps,
  HTMLAttributes,
  isValidElement,
  useState,
} from "react";
import {
  Button,
  List,
  ListProps,
  Pagination,
  PaginationProps,
  TopToolbar,
} from "react-admin";
import { Menu, MenuItem } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import { useResourceExport } from "../../../common/hooks/useResourceExport";

const PostPagination = (props: PaginationProps) => (
  <Pagination rowsPerPageOptions={[25, 50, 100]} {...props} />
);

type DefaultProLogsListProps = ListProps & {
  children: any;
  canExport?: boolean;
} & Omit<
    DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    "title"
  >;

const ExportButton = () => {
  const { handleExport, isExporting } = useResourceExport({
    exportFormat: "xlsx",
  });
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const formats = [
    { id: "xlsx", label: "XLSX" },
    { id: "csv", label: "CSV" },
    { id: "pdf", label: "PDF" },
  ];

  const openMenu = (e: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(e.currentTarget);
  const closeMenu = () => setAnchorEl(null);

  const handleSelect = (fmt: { id: string; fileName?: string }) => {
    closeMenu();
    handleExport(fmt.id, fmt.fileName);
  };

  return (
    <>
      <Button
        label="Export"
        onClick={openMenu}
        disabled={isExporting}
        startIcon={<GetAppIcon />}
      />
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={closeMenu}
      >
        {formats.map((f) => (
          <MenuItem key={f.id} onClick={() => handleSelect(f)}>
            {f.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

const DefaultActions = ({
  actions,
  canExport = true,
}: {
  actions?: React.ReactElement | false | undefined;
  canExport?: boolean;
}) => {
  const actionsContent = isValidElement(actions) ? actions : undefined;

  return (
    <TopToolbar>
      {canExport && <ExportButton />}
      {actionsContent}
    </TopToolbar>
  );
};

export const DefaultProLogsList = (props: DefaultProLogsListProps) => {
  const { actions, canExport = true, ...rest } = props;
  const combinedActions = (
    <DefaultActions actions={actions} canExport={canExport} />
  );

  return (
    <List
      {...rest}
      actions={combinedActions}
      pagination={<PostPagination />}
      perPage={25}
    />
  );
};
